import { render, staticRenderFns } from "./DiagnosisSelect.vue?vue&type=template&id=4e72401f&lang=pug"
import script from "./DiagnosisSelect.vue?vue&type=script&lang=js"
export * from "./DiagnosisSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports